import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { faFileCode, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { MachineServiceData } from 'src/api/generated';
import { MachineOwnerService } from 'src/app/shared/services/owner.service';
import { ServiceDataService } from 'src/app/shared/services/service-data.service';
import { confirm } from 'devextreme/ui/dialog';
import { TranslateWithFallbackPipe } from 'acl-cloud-lib';

@Component({
  selector: 'app-service-data',
  templateUrl: './service-data.component.html',
  styleUrl: './service-data.component.scss'
})
export class ServiceDataComponent {
  faFileCode = faFileCode;
  faTrashCan = faTrashCan;
  isSmallScreen: boolean = false;

  constructor(
    private readonly _sdSvc: ServiceDataService,
    private readonly _oSvc: MachineOwnerService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly _translate: TranslateWithFallbackPipe
  ) { }

  ngOnInit(): void {
    this._sdSvc.refreshusersCache();

    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        this.isSmallScreen = state.matches;
      });
  }

  public get SdSvc(): ServiceDataService {
    return this._sdSvc;
  }

  async onDeleteData(rowData: MachineServiceData){
    if (rowData) {
      if (await confirm(this._translate.transform(''), this._translate.transform('delete-confirmation'))) {
        this._sdSvc.Deleted(rowData.Id ?? "");
      }
    }
  }

  public get OSvc(): MachineOwnerService {
    return this._oSvc;
  }

  getOwnerName(ownerId: string): string {
    const owner = this.OSvc.AllOwners.find(o => o.Id === ownerId);
    return owner ? owner.Name ?? "" : '-';
  }

  getUserName(userId: string): string {
    const user = this.SdSvc.AllUsers.find(u => u.Id === userId);
    return user ? user.Name ?? '-' : '-';
  }
}
